import React, { useEffect, useState } from "react"
import { useRouter } from "next/router"
import { getShortenedUrl, sanitizeInnerHtml } from "@/utils/helper"
const Text = props => {
  const [dataVal, setDataVal] = useState("")
  const { asPath = "" } = useRouter()
  const isFaqPage = asPath.split(/[?#]/)[0].replace(/\/$/, "") === "/help/faq"

  const {
    data: {
      text = "",
      appliedCssClassNames = "",
      richText = false,
      id = "",
    } = {},
  } = props
  useEffect(() => {
    if (!richText) return
    let cancelled = false
    const updateText = async () => {
      const newData = await getShortenedUrl(text)
      let html = newData.replace('href=""', 'href="/"')
      if (isFaqPage) {
        const document = new DOMParser().parseFromString(html, "text/html")
        document.querySelectorAll('ol a[href^="#"]').forEach(link => {
          const label = link.textContent.replace(/\s+/g, " ").trim()
          if (
            link.getAttribute("href").length > 1 &&
            label &&
            !link.hasAttribute("aria-label") &&
            !link.hasAttribute("aria-labelledby")
          ) {
            link.setAttribute("aria-label", `${label} FAQs`)
          }
        })
        html = document.body.innerHTML
      }
      if (!cancelled) setDataVal(html)
    }
    updateText()
    return () => {
      cancelled = true
    }
  }, [richText, text, isFaqPage])

  return (
    <div className={`text ${appliedCssClassNames ? appliedCssClassNames : ""}`}>
      {richText ? (
        <div id={id} className="cmp-text">
          {sanitizeInnerHtml(dataVal)}
        </div>
      ) : (
        <div className="cmp-text">
          <p className="cmp-text__paragraph">
            {text}
          </p>
        </div>
      )}
    </div>
  )
}

export default Text
